import "./BpoServices.module.css";
import Header from "@/reusable_sections/Header";
import TailoredSolutions from "./sections/TailoredSolutions";
import ThePerfectProtocol from "./sections/ThePerfectProtocol";
import WhyShopWithUs from "./sections/WhyShopWithUs";
import FooterInfo from "@/reusable_sections/Footer";
export default function BpoServicesPage() {
  return <div>
      <Header />
      <TailoredSolutions />
      <ThePerfectProtocol />
      <WhyShopWithUs />
      <FooterInfo />
    </div>;
}